import React from "react";
import { InlineWidget } from "react-calendly";

const Contact = () => {
  return (
    <div style={{ marginTop: "2rem" }}>
      <InlineWidget style={{ overflowY: "hidden" }} url="https://calendly.com/meliorist-dev/roadmapping" />
    </div>
  );
};

export default Contact;
